import { createElement } from 'react';
import { SocialMediaIcons } from '../Foundation/SocialMediaIcons';
export const renderSocialMediaIcons = icons => icons && !!SocialMediaIcons[icons] ? /*#__PURE__*/createElement(SocialMediaIcons[icons]) : undefined;